<div class="parent">
  <div class="type-n-settings" [class.flex-end]="!showFilterTypeInput">
    <ng-container *ngTemplateOutlet="filterTypeOptions"></ng-container>
    <ng-container *ngTemplateOutlet="filterSettings"></ng-container>
  </div>
  <mode-filter-value-list
    *ngIf="step === FilterStepEnum.MultiValues"
    [view]="view"
    [encoding]="encoding"
    [field]="field"
    [filter]="filter"
    [queryRunToken]="queryRunToken"
    (filterChange)="multiValueFilterChanged($event)"
    (isInvalid)="invalidationChanged($event)"
  ></mode-filter-value-list>
  <mode-rank-panel
    *ngIf="step === FilterStepEnum.TopByField"
    [view]="view"
    [encoding]="encoding"
    [filterField]="field"
    [filterCondition]="currentTopNCondition"
    (filterChange)="topNFilterConditionChanged($event)"
    (isInvalid)="invalidationChanged($event)"
  ></mode-rank-panel>
</div>

<ng-template #filterTypeOptions>
  <div class="discrete-filter-type-options" *ngIf="showFilterTypeInput">
    <div class="radio-icon">
      <input
        id="list"
        type="radio"
        name="multi-values-step-radio"
        [value]="FilterStepEnum.MultiValues"
        [(ngModel)]="step"
        (ngModelChange)="onStepChange()"
      />
      <label for="list" class="radio-label inline-icon icon-radio-inactive">List</label>
    </div>
    <div class="radio-icon">
      <input
        id="rank"
        type="radio"
        name="multi-values-step-radio"
        [value]="FilterStepEnum.TopByField"
        [(ngModel)]="step"
        (ngModelChange)="onStepChange()"
      />
      <label for="rank" class="radio-label inline-icon icon-radio-inactive">Top/Bottom N</label>
    </div>
  </div>
</ng-template>

<ng-template #filterSettings>
  <div class="discrete-filter-settings" *ngIf="showFilterSettings">
    <capra-icon-button
      icon="icon-gear"
      size="medium"
      aria-label="Filter options menu"
      data-test="filter-options-menu-button"
      [matMenuTriggerFor]="menu"
    ></capra-icon-button>
    <mat-menu #menu="matMenu" class="filter-settings-menu">
      <button mat-menu-item *ngIf="step === FilterStepEnum.MultiValues" (click)="toggleExclude()">
        <capra-icon icon="icon-check" [style.visibility]="excludeValues ? 'visible' : 'hidden'"></capra-icon
        ><span>Exclude selected values</span>
      </button>

      <button mat-menu-item *ngIf="step === FilterStepEnum.MultiValues" (click)="toggleShowRelevantValues()">
        <capra-icon icon="icon-check" [style.visibility]="showRelevantValues ? 'visible' : 'hidden'"></capra-icon
        ><span>Only display relevant values</span>
      </button>

      <ng-container *ngIf="showWeekStartOptions">
        <mat-divider *ngIf="step === FilterStepEnum.MultiValues"></mat-divider>
        <div mat-menu-item>
          <strong>Start of week</strong>
        </div>
        <button mat-menu-item *ngFor="let ws of weekStartOptions" (click)="setWeekStart(ws.value)">
          <capra-icon
            icon="icon-dot-indicator"
            [style.visibility]="weekStart === ws.value ? 'visible' : 'hidden'"
          ></capra-icon>
          <span>{{ ws.name }}</span>
          <span *ngIf="(isCustomCalenderSettingsEnabled$ | async) && defaultWeekStart === ws.value"
          class="menu-item-info">Org Default</span>
        </button>
      </ng-container>

      <ng-container *ngIf="showYearStartOptions">
        <mat-divider *ngIf="step === FilterStepEnum.MultiValues"></mat-divider>
        <div mat-menu-item>
          <strong>Start of year</strong>
        </div>
        <button mat-menu-item *ngFor="let ys of yearStartOptions" (click)="setYearStart(ys.value)">
          <capra-icon
            icon="icon-dot-indicator"
            [style.visibility]="yearStart === ys.value ? 'visible' : 'hidden'"
          ></capra-icon>
          <span>{{ ys.name }}</span>
          <span *ngIf="(isCustomCalenderSettingsEnabled$ | async) && defaultYearStart === ys.value"
            class="menu-item-info">Org Default</span>
        </button>
      </ng-container>
    </mat-menu>
  </div>
</ng-template>
